import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import UploadThreeDModelButton from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/UploadThreeDModelButton'

function InitialBannerState() {
  const t = useTranslation()

  return (
    <div className="banner">
      <div className="banner__content">
        <img
          className="banner__icon"
          src="/assets/three_d_studio/initial_banner/cube.webp"
          alt=""
          aria-hidden="true"
          width="96"
          height="96"
        />
        <h2 className="banner__title cgt-heading-300">
          {t('viewer.banner.initial')}
        </h2>
        <div className="banner__upload">
          <UploadThreeDModelButton withLabel />
        </div>
      </div>
    </div>
  )
}

export default memo(InitialBannerState)
